const { cELM } = require("../../utils");
const Chat = require("../../chat");

const MEDIA_CONSTRAINTS = {
  audio: false,
  video: {
    facingMode: { exact: "environment" },
    width: 9999
  }
}

/**
 * Asks for permission to use the camera when the user selects a Yes type of answer.
 * When the user clicks on the popup it answers the question
 */
class CameraRequest {
  constructor(data) {
    this.options = data.values.split("|");
    this.element = cELM("div", "option-block");

    this.getLanguage((data || {}).id);
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;

    this.options.forEach((op, idx) => {
      op = op.trim();
      const className = (op || '').indexOf('<div class="rate-') > -1 ? ' rate-opt' : '';
      const _el = cELM("div", 'option' + className);

      _el.onclick = function(evt) {
        _el.classList.toggle("option-active");
        // REMOVE THE LINE BELOW TO ENABLE ASKING FOR CAMERA PERMISSIONS
        return _self.sendMessage(op, _self.element);

        // If no media devices available just send the answer
        if (!_self.hasUserMedia() || !_self.isYesAnswer(op)) {
          return _self.sendMessage(op, _self.element)
        }

        navigator.mediaDevices.getUserMedia(MEDIA_CONSTRAINTS).then((mediaStream) => {
          window.mediaStream = mediaStream;
        })
        .then(() => _self.sendMessage(op, _self.element))
        .catch(() => _self.sendMessage(op, _self.element));
      };

      _el.innerHTML = '<div class="option-text">' + op + "</div>";
      this.element.addELM(_el);
    });

    return this.element;
  }

  hasUserMedia() {
    return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
  }

  sendMessage(op, element) {
    if (window.__FN_DATA_WRAPPER) {
      Chat.default.send(window.__FN_DATA_WRAPPER(op), null, element);
    } else {
      Chat.default.send(op, null, element);
    }
  }

  getLanguage(questionnaire) {
    if ((questionnaire || '').toLowerCase().indexOf("/spa/") > -1) {
      this.language = {
        yes: ['si', 'sí']
      };
    } else {
      this.language = {
        yes: ['yes', 'ok']
      }
    }
  }

  isYesAnswer(answer) {
    for(const yes of this.language.yes) {
      if (answer.toLowerCase().startsWith(yes)) {
        return true;
      }
    }

    return false;
  }

  reset() {}
  focus() {}
}

module.exports = CameraRequest;